"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _OfferStyled = require("../Offer/OfferStyled");
var _Header = _interopRequireDefault(require("../Header"));
var _Footer = _interopRequireDefault(require("../Footer"));
var _finalizePaymentSlice = require("../../redux/finalizePaymentSlice");
var _reactRedux = require("react-redux");
var _StyledOfferContainer = require("../../containers/OfferContainer/StyledOfferContainer");
var _Loader = _interopRequireDefault(require("../Loader"));
var _ThankYouPage = _interopRequireDefault(require("../ThankYouPage"));
var _FailedPaymentPage = _interopRequireDefault(require("../FailedPaymentPage"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PaymentFinalizationPage = _ref => {
  let {
    onSuccess
  } = _ref;
  const adyenRedirectResult = new URLSearchParams(window.location.search).get('redirectResult');
  const orderId = new URLSearchParams(window.location.search).get('orderId');
  const dispatch = (0, _reactRedux.useDispatch)();
  const submitRedirectResult = () => {
    dispatch((0, _finalizePaymentSlice.fetchFinalizeInitialPayment)({
      orderId,
      details: {
        redirectResult: adyenRedirectResult
      }
    })).then(() => {
      window.history.replaceState(null, null, window.location.pathname);
    });
  };
  const {
    error,
    payment
  } = (0, _reactRedux.useSelector)(state => state.finalizeInitialPayment);
  (0, _react.useEffect)(() => {
    if (adyenRedirectResult && orderId) {
      submitRedirectResult();
    }
  }, []);
  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FailedPaymentPage.default, {});
  }
  if (payment.id) {
    if (onSuccess) {
      onSuccess();
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThankYouPage.default, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OfferStyled.StyledOfferWrapper, {
    "data-testid": "PaymentFinalizationPage-loader",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledOfferContainer.StyledLoaderContent, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.default, {})]
  });
};
var _default = exports.default = PaymentFinalizationPage;
PaymentFinalizationPage.propTypes = {
  onSuccess: _propTypes.default.func
};
PaymentFinalizationPage.defaultProps = {
  onSuccess: null
};